// test269
(269 && 0);
